import { render, staticRenderFns } from "./driverBan.vue?vue&type=template&id=25a66aaa&scoped=true"
import script from "./driverBan.vue?vue&type=script&lang=js"
export * from "./driverBan.vue?vue&type=script&lang=js"
import style0 from "./driverBan.vue?vue&type=style&index=0&id=25a66aaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a66aaa",
  null
  
)

export default component.exports